import { create } from 'zustand';

interface SidebarType {
  isOpen: boolean;
  setIsOpen: (value?: boolean) => void;
}

const useSidebarStore = create<SidebarType>((set) => ({
  isOpen: true,
  setIsOpen: (value?: boolean) =>
    set((state) => ({ ...state, isOpen: value ?? !state.isOpen })),
}));

export default useSidebarStore;
